import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navigation } from './Navigation';
import { AnimatedBackground } from './AnimatedBackground';
import { SitePromoModal } from './SitePromoModal';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="relative min-h-screen">
      <AnimatedBackground />
      
      {/* Content */}
      <div className="relative z-10">
        <Navigation />
        <SitePromoModal />
        <main>
          {children}
        </main>
      </div>

      {/* Global Animations */}
      <style>
        {`
          @keyframes moveGrid {
            0% {
              transform: translate(0, 0);
            }
            100% {
              transform: translate(4rem, 4rem);
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translate(0, 0);
            }
            25% {
              transform: translate(50px, -50px);
            }
            50% {
              transform: translate(100px, 0);
            }
            75% {
              transform: translate(50px, 50px);
            }
          }
        `}
      </style>
    </div>
  );
}; 